@if(initialized) {

  <otp
    [isOtpParentConfirmation]="true"
    [isLoginOtpFlow]="true"
    [requestOtpBusy]="requestOtp"
    [confirmOtpBusy]="confirmOtp"
    [externalErrorMessage]="otpErrorMessage"
    (onConfirmOtp)="handleConfirmOtp($event)"
    (onRequestOtp)="handleRequestOtp($event)"
    (routeBack)="handleStepComplete($event)"
  >
  </otp>

<!--  <p-inputNumber class="block" styleClass="block" [inputStyle]="{'padding-left': '6rem', width: '100%'}"-->
<!--                 [format]="false"-->
<!--                 [(ngModel)]="enteredOTP" />-->

<!--  <p-button (click)="handleConfirmOtp()" label="proceed"></p-button>-->

}
